<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs" id="custom-content-above-tab" role="tablist">
              <li class="nav-item">
                <router-link to="/cashback_unpaid" class="nav-link">
                   CASHBACK</a>
                </router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link active" data-toggle="pill" href="javascript:void(0)" aria-selected="true">  PPN KELUARAN</a>
              </li>
              <li class="nav-item">
                <router-link to="/pph_unpaid" class="nav-link">
                   PPH 23</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/zakat_unpaid" class="nav-link">
                  ZAKAT</a>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
                    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Daftar PPN Keluaran Unpaid <small></small></h3>
                <div class="card-tools">
                </div>
              </div>
              <!-- /.card-header -->
              <v-app>
                <v-main>
                  <div class="card-body ">
                    <div class="row">
                      <div class="col-lg-6 col-6">
                        <div class="small-box bg-primary">
                            <div class="inner">
                                <h3>{{parseInt(jlh_data)}}</h3>
                                <small>Jumlah PPN Keluaran Unpaid</small>
                                <!--p>dari {{parseInt(jlh_invoice)}} Unpaid Bulan Ini</p-->
                            </div>
                            <div class="icon">
                                <i class="fas fa-users"></i>
                            </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-6">
                        <div class="small-box bg-primary">
                            <div class="inner">
                                <h3>{{parseInt(ttl_data) | toCurrency}}</h3>
                                <small>Total Rp PPN Keluaran Unpaid</small>
                                <!--p>Unpaid Bulan Ini</p-->
                            </div>
                            <div class="icon">
                                <i class="fas fa-money-bill"></i>
                            </div>
                        </div>
                      </div>
                    </div>
                    <!-- Print -->
                    <div class="row">
                      <div class="col-4">
                        <label>Jumlah Pelanggan Terpilih:</label>
                        <h5>  {{ listItemSelekID.length }}</h5>
                      </div>
                      <div class="col-4">
                        <label>Jumlah Rp Terpilih:</label>
                        <h5>  {{ listItemSelekRP | toCurrency }}</h5>
                      </div>
                      <div class="col-4">
                        <button type="button" class="btn btn-success float-right" :disabled="listItemSelekID.length < 1" @click="updateCashback()"> Request Pengeluaran</button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-12">
                        <v-text-field
                          class="col-md-4 offset-md-8 mb-1"
                          v-model="cari_dt_plg"
                          append-icon="mdi-magnify"
                          label="Pencarian"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-data-table
                          :headers="headers"
                          :footer-props="{ itemsPerPageOptions: [10,25,50,100,-1]}"
                          :items="datas"
                          :items-per-page="25"
                          item-key="id"
                          sort-by="no"
                          class="elevation-1 "
                          show-group-by
                          :search="cari_dt_plg">
                          <template v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                            <td :colspan="headers.length-1">
                              <v-btn @click="toggle" x-small icon :ref="group">
                                  <v-icon v-if="isOpen">mdi-minus</v-icon>
                                  <v-icon v-else>mdi-plus</v-icon>
                              </v-btn>
                              <span class="mx-3"> Nama Pelanggan : <span class="font-weight-bold"> {{ group }}</span></span>
                              <!--a href="#" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                                <i class="fa fa-user-edit text-blue"></i>
                              </a-->
                            </td>
                            <td>
                              <v-btn @click="remove" x-small icon class="">
                                  <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <template v-slot:header.checkbox>
                            <input type="checkbox" @click="checkAll()" v-model="isCheckAll">
                          </template>
                          <template v-slot:item.checkbox="{ item }">
                            <v-container
                              class="px-0"
                              fluid
                            >
                              <v-checkbox @change="updateCheckall(item)" v-model="listItemSelek" v-bind:value="item"
                              ></v-checkbox>
                            </v-container>
                          </template>
                          <template v-slot:item.bulan_pemakaian="{ item }">
                            {{ getBulan(item.bulan_pemakaian) }}
                          </template>
                          <template v-slot:item.kickback="{ item }">
                            {{ item.kickback | toCurrency }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <!--a href="#" v-if="!table_group_state" class="mr-1" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                              <i class="fa fa-user-edit text-blue"></i>
                            </a-->
                            <div class="tanpawrap">
                              <a href="#" class="mr-1" @click="printInvoice(item)" title="Lihat Invoice">
                                <i class="fa fa-file text-yellow"></i>
                              </a>
                              /
                              <a href="#" class="ml-1" @click="bukaModal(item)" title="View Data">
                                <i class="fa fa-eye text-blue"></i>
                              </a>
                            </div>
                            <!--a href="#" class="ml-1" @click="false">
                              <i class="fas fa-trash text-red"></i>
                            </a-->
                            <!--a href="#" @click="deleteProduct(item.id)">
                              <i class="fas fa-trash text-red"></i>
                            </a-->
                            
                          </template>
                          <template v-slot:no-data>
                            <h4>Data Tidak Ditemukan</h4>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <label>Jumlah Pelanggan Terpilih:</label>
                        <h5>  {{ listItemSelekID.length }}</h5>
                      </div>
                      <div class="col-4">
                        <label>Jumlah Rp Terpilih:</label>
                        <h5>  {{ listItemSelekRP | toCurrency }}</h5>
                      </div>
                      <div class="col-4">
                        <button type="button" class="btn btn-success float-right" :disabled="listItemSelekID.length < 1" @click="updateCashback()"> Request Pengeluaran</button>
                      </div>
                    </div>
                  </div>
                </v-main>
              </v-app>
              <!-- /.card-body -->
        
              <div class="card-footer">
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
    </div>
          <div class="modal fade " id="modalEdit" tabindex="-1" role="dialog" aria-labelledby="modalEdit" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Penyelesaian PPN Keluaran</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="bayarCashback()" enctype="multipart/form-data" id="formnya">
                    <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card card-outline card-primary">
                              <div class="card-header">
                                <h3 class="card-title" style="margin:0px">Data Pelanggan</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                
                                
                                <hr style="border:1px solid;"/>
                                <h5>Data Billing</h5>
                                
                              </div>
                              <!-- /.card-body -->
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                isCheckAll: false,
                listItemSelek: [],
                listItemSelekID: [],
                listItemSelekRP: 0,
                jlh_cashback: '0',
                jlh_data: '0',
                ttl_cashback: '0',
                ttl_data: '0',
                cari_dt_plg: '',
                datas : [],
                headers: [
                  { text: "#", align: 'start', value: 'checkbox', sortable: false, groupable: false, },
                  { text: 'No Inv', value: 'id', groupable: false, },
                  { text: 'ID PLG', value: 'inet_id', sortable: false, groupable: false, },
                  { text: 'Tempat Instalasi', value: 'nama_tempat', groupable: false, },
                  { text: 'Periode', value: 'bulan_pemakaian', groupable: false, },
                  { text: 'Tanggal Bayar INV', value: 'tanggal_bayar', groupable: false, },
                  { text: 'Jumlah RP', value: 'kickback', groupable: false, },
                  { text: 'Aksi', value: 'actions' , sortable: false, groupable: false,},
                ],
                form: new Form({cashback : {
                    no_inv: '',
                    bukti: '',
                  }
                }),
                adaeror : [],
            }
        },
        methods: {
          checkAll(){
            this.isCheckAll = !this.isCheckAll;
            this.listItemSelek = [];
            this.listItemSelekID = [];
            this.listItemSelekRP = 0;
            
            if(this.isCheckAll){ // Check all
              for (var key in this.datas) {
                this.listItemSelek.push(this.datas[key]);
                this.listItemSelekID.push(this.datas[key].id);
                this.listItemSelekRP += parseFloat(this.datas[key].kickback);
              }
            }
          },
          updateCheckall(e){
            const indexRemove = this.listItemSelekID.indexOf(e.id);
            if(indexRemove > -1 ){
              this.listItemSelekID.splice(indexRemove,1);
              this.listItemSelekRP -= parseFloat(e.kickback);
            }else{
              this.listItemSelekID.push(e.id);
              this.listItemSelekRP += parseFloat(e.kickback);
            }
            if(this.listItemSelek.length == this.datas.length){
              this.isCheckAll = true;
            }else{
              this.isCheckAll = false;
            }
          },
          downloadFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: 'application/pdf'});

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download = filename + '.pdf'
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
          },
          printInvoice(item){
            this.$Progress.start();
            let namaFileDownload = "Invoice " + item.nama + " " + item.bulan_pemakaian;
            axios.get('api/invoice/printpdf?id_invoice='+item.id, {responseType: 'blob'}).then(response => {
              this.downloadFile(response, namaFileDownload);
              this.$Progress.finish();
            }, response => {
                Toast.fire({
                    icon: 'error',
                    title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
                });
                this.$Progress.fail();
            });
          },
          preventArrow(e) {
            if (e.which === 38 || e.which === 40) {
              e.preventDefault();
            }
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57)
            {
                e.preventDefault();
            }
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          updateCashback(){
            this.$Progress.start();
            Swal.fire({
              title: 'Are you sure?',
              text: "Apakah Anda Yakin Untuk Membuat Pengeluaran PPN KELUARAN Pelanggan Terpilih?",
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                let editFormData = new FormData();
                let dataUpdate = {};
                dataUpdate['id'] = this.listItemSelekID;
                dataUpdate['rp'] = this.listItemSelekRP;
                dataUpdate['fulldata'] = this.listItemSelek;


                editFormData.append('datanya', JSON.stringify(dataUpdate));
                axios.post('api/ppn/bayar', editFormData).then((data) => {
                  if(data.data.success){

                      Toast.fire({
                          icon: 'success',
                          title: data.data.message
                      });
                      this.isCheckAll= false,
                      this.listItemSelek= [],
                      this.listItemSelekID= [],
                      this.listItemSelekRP= 0,
                      this.$Progress.finish();
                      this.loadUnpaid();
                      $('#modalEdit').modal('hide');
                  } else {
                      Toast.fire({
                          icon: 'error',
                          title: data.data.data ? data.data.data : "Error!. Try again later."
                      });

                      this.$Progress.fail();
                  }
                })
                .catch(e => {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!."
                    });
                    //console.log( e.response.data.errors);

                    this.$Progress.fail();
                });
              }
            })
          },
          bukaModal(item){
            this.adaeror = [];
            this.form.reset();
            $('#modalEdit').modal('show');
          },
          tableGrouping(e) {
            if(e.length){
              this.table_group_state = true;
            }else{
              this.table_group_state = false;
            }
          },
          loadUnpaid(){
            this.ttl_data = 0;
            this.jlh_data = 0;
            if(this.$gate.isAllowed("is_keuangan")){
              
              if(this.$gate.dataType('1')){
                axios.get("api/ppn/list_unpaid").then(({ data }) => (this.datas = data.data));
                axios.get("api/ppn/list_unpaid_count").then(({ data }) => {
                  this.jlh_data += parseInt(data.data[0].jumlah ? data.data[0].jumlah : 0);
                  this.ttl_data += parseInt(data.data[0].total ? data.data[0].total : 0);
                });
              }
            }
          },
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadUnpaid();

            this.$Progress.finish();
        },
    }
</script>
<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.tanpawrap {
  white-space: nowrap;
}
</style>